import { ButtonClean, ButtonPrimary, Modal } from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'
import React, { useState } from 'react'
import SelectTimezone from '../../../../../components/common/SelectTimezone'

export const EventTimezoneModal = ({ resolve, reject, timezone }) => {
  const [value, setValue] = useState(timezone)

  return (
    <Modal
      newDesign
      header={t`Timezone of Event`}
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary onClick={() => resolve(value)}>
            <Trans>Done</Trans>
          </ButtonPrimary>
        </>
      }
      onHide={reject}
    >
      <SelectTimezone
        value={value}
        name="timezone"
        guess
        onChange={(val) => setValue(val)}
        dataTest="SelectTimezone"
      />
    </Modal>
  )
}
